import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { AccountBasicData } from 'src/app/models/account/account-basic-data.model';
import { AppUser } from 'src/app/models/app-user.model';
import { Account } from 'src/app/models/account.model';
import { AccountService } from 'src/app/services/account.service';
import { BannerService } from 'src/app/services/banner.service';
import { CommonService } from 'src/app/services/common.service';
@Component({
  selector: "app-banner",
  templateUrl: "./banner.component.html",
  styleUrls: ["./banner.component.scss"],
})
export class BannerComponent implements OnInit {
  slides: string[] = [];
  slidesCinta: string[] = [];
  /*slides = [
	{ img: 'assets/images/web-portal/sliders/slider-home/slide1.jpg'
   },
    { img: 'assets/images/web-portal/sliders/slider-home/slide2.jpg' },
    { img: 'assets/images/web-portal/sliders/slider-home/slide3.jpg' },
    { img: 'assets/images/web-portal/sliders/slider-home/slide4.jpg' }
  ];
  */
  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<i class="material-icons slick-ArrowLeft">chevron_left</i>',
    nextArrow: '<i class="material-icons slick-ArrowRight">chevron_right</i>',
    autoplay: true,
    autoplaySpeed: 12000
  };

  slideCintaConfig = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: false,
    nextArrow: false,
    autoplay: true,
    autoplaySpeed: 8000
  }
  accountBasicData: AccountBasicData;
  account: Account;
  private appUser: AppUser;

  constructor(private bannerService: BannerService,
    private accountService: AccountService,
    private authService: AuthService,
    private commonService: CommonService) { }

  async ngOnInit() {
    await this.getAcountSelect().then(() => {
      // console.log(this.lstBanner);
      // console.log(this.lstCinta);
    });
  }

  lstBanner:any[];
  lstCinta:any[];

  async getAcountSelect()
  {
    //console.log('paso 1');
    await this.commonService.accountSelectedAnnounced.subscribe(account => {
      this.account = account;
      this.accountService.getBasicData(this.account.clientCode).subscribe(response =>
        {
          this.accountBasicData = response.data;
          this.bannerService.getbannerByUser(this.accountBasicData.clientTypeCode).subscribe(response => {
            //console.log(response.data);
            this.lstBanner = response.data.filter(q=> (q.displayCode == 'TVB0' || q.displayCode == 'TVB1') && q.publicationTypeCode == 'TP0' && q.imageWebSourceLink !== '');
            this.lstCinta = response.data.filter(q=> (q.displayCode == 'TVB0' || q.displayCode == 'TVB1') && q.publicationTypeCode == 'TP1'  && q.imageWebSourceLink !== '');

            
            // console.log(this.lstBanner);
            // console.log(this.lstCinta);

            this.lstBanner.forEach(e=>{ this.slides.push(e.imageWebSourceLink); });
            this.lstCinta.forEach(e=>{ this.slidesCinta.push(e.imageWebSourceLink); });
          });
          this.commonService.announceAccountDataFetched(response.data);
        });
    });
    
  }

  goToLink(url: string){
    if(url)
      window.open(url, "_blank");
  }

  // async getBasicData()
  // {
  //   console.log(this.account);
  //   console.log('paso 2');
  //   await this.accountService.getBasicData(this.account.clientCode).toPromise().then(response =>
  //   {
  //     this.accountBasicData = response.data;
      
  //   });
  // }

  // async getBannerBan()
  // {
  //   console.log('paso 3');
  //   await this.bannerService.getbannerByUser(this.account.clientCode).subscribe(response => {
      
  //     console.log(response);
  //   });
  // }

  
}
